import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-field-title',
  templateUrl: './field-title.component.html',
  standalone: false
})

export class FieldTitleComponent {

  // hint: an optional italic line under the title, set by the host screen (DetailInfo.hint).
  @Input() titleInfo!: { title?: string, description?: string, hint?: string };
  @Input() formControlObj!: AbstractControl & any;

}
